module.exports = __webpack_public_path__ + "2f0f3aa4bd7aae2dbfa4288cdc8da735.png";